module.exports = __webpack_public_path__ + "34736292/img/splash-icon.07a7c465.svg";